export class MapsConfig {
  apiKey = '';
  libraries?: string[];
}
